export const identity = {
    yourIdentity: {
        revealIdentity: 'Tożsamość zgłaszającego',
        yesRevealIdentity: 'Tak, chcę ujawnić moją tożsamość',
        noDontRevealIdentity: 'Nie, nie chcę ujawniać mojej tożsamości',
    }
};
